import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MapServiceService } from 'src/app/modules/map/services/Map-service/map-service.service';

import { DashboardServiceService } from '../../services/dashboard-service.service';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
})
export class NavbarComponent implements OnInit {
  showDemigod: any;
  username: any;
  firstName: any;
  lastName: any;
  decrypted: any;
  userEn = 'userEncrpto';
  constructor(
    private router: Router,
    public dashboardService: DashboardServiceService,
    public mapServices: MapServiceService
  ) {
    //
  }

  ngOnInit(): void {
    this.dashboardService.showBackToDemigod.subscribe((res: any) => {
      this.showDemigod = res;
    });

    this.dashboardService.user.subscribe(() => {
      this.updateValue();
    });
    const data = localStorage.getItem('demigodBack');
    this.updateValue();
    setTimeout(() => {
      if (data) {
        this.showDemigod = true;
      }
    }, 500);
  }

  //updating first and last name in navbar
  updateValue() {
    this.decrypted = localStorage.getItem('user') || '';
    if (!this.decrypted) {
      this.firstName = '';
      this.lastName = '';
    } else {
      const decrypted = CryptoJS.AES.decrypt(this.decrypted, this.userEn);
      const user = decrypted.toString(CryptoJS.enc.Utf8);
      const userdetail = JSON.parse(user);
      if (userdetail) {
        this.firstName = userdetail.user.first_name;
        this.lastName = userdetail.user.last_name;
      }
    }
  }

  logOut(): void {
    this.dashboardService.mapsAndProfile = null;
    localStorage.clear();
    this.router.navigate(['login']);
  }

  backToDemigod() {
    this.dashboardService.mapsAndProfile = null;
    localStorage.clear();
    window.location = <any>`${environment.operatorDashboardUrl}/maps/`;
  }
}
